import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { dgWithReducer } from 'dg-utils';
import { logout } from './loginActions.mjs';
import loginReducer from './loginReducer.mjs';
import './types-0b7e03a3.js';
import '@babel/runtime/helpers/defineProperty';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Sidebar = /*#__PURE__*/function (_Component) {
  _inherits(Sidebar, _Component);

  var _super = _createSuper(Sidebar);

  function Sidebar(props) {
    var _this;

    _classCallCheck(this, Sidebar);

    _this = _super.call(this, props);
    _this.state = {
      loggedIn: false,
      isProfileMenuOpen: false
    };
    _this.onLogout = _this.onLogout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Sidebar, [{
    key: "onLogout",
    value: function onLogout(e) {
      this.props.logout().then(function (res) {
        Swal.fire("Success!", res.message, "success");
      })["catch"](function (res) {
        Swal.fire("Error!", res.message, "error");
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("nav", {
        className: "dg-admin-sidebar"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "navbar-nav"
      }, /*#__PURE__*/React.createElement("li", {
        className: "logo"
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/",
        className: "nav-link"
      }, /*#__PURE__*/React.createElement("span", {
        className: "link-text"
      }, process.env.REACT_APP_PROJECT_NAME), /*#__PURE__*/React.createElement("svg", {
        "aria-hidden": "true",
        focusable: "false",
        "data-prefix": "fad",
        "data-icon": "angle-double-right",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512",
        className: "svg-inline--fa fa-angle-double-right fa-w-14 fa-5x"
      }, /*#__PURE__*/React.createElement("g", {
        className: "fa-group"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M224 273L88.37 409a23.78 23.78 0 0 1-33.8 0L32 386.36a23.94 23.94 0 0 1 0-33.89l96.13-96.37L32 159.73a23.94 23.94 0 0 1 0-33.89l22.44-22.79a23.78 23.78 0 0 1 33.8 0L223.88 239a23.94 23.94 0 0 1 .1 34z",
        className: "fa-secondary"
      }), /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M415.89 273L280.34 409a23.77 23.77 0 0 1-33.79 0L224 386.26a23.94 23.94 0 0 1 0-33.89L320.11 256l-96-96.47a23.94 23.94 0 0 1 0-33.89l22.52-22.59a23.77 23.77 0 0 1 33.79 0L416 239a24 24 0 0 1-.11 34z",
        className: "fa-primary"
      }))))), this.props.routes.map(function (route, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: "dg-admin-route-".concat(index),
          className: "nav-item"
        }, /*#__PURE__*/React.createElement(Link, {
          to: route.url,
          className: "nav-link"
        }, /*#__PURE__*/React.createElement("svg", {
          "aria-hidden": "true",
          focusable: "false",
          "data-prefix": "fas",
          "data-icon": "list",
          className: "svg-inline--fa fa-list fa-w-16",
          role: "img",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 512 512"
        }, /*#__PURE__*/React.createElement("path", {
          fill: "currentColor",
          d: "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z",
          className: "fa-primary"
        })), /*#__PURE__*/React.createElement("span", {
          className: "link-text"
        }, route.text)));
      }), /*#__PURE__*/React.createElement("li", {
        className: "nav-item logout"
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/",
        onClick: this.onLogout,
        className: "nav-link"
      }, /*#__PURE__*/React.createElement("span", {
        className: "link-text"
      }, "Log Out"), /*#__PURE__*/React.createElement("svg", {
        "aria-hidden": "true",
        focusable: "false",
        "data-prefix": "fas",
        "data-icon": "sign-out-alt",
        className: "svg-inline--fa fa-sign-out-alt fa-w-16",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z",
        className: "fa-primary"
      }))))));
    }
  }]);

  return Sidebar;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    logout: function logout$1() {
      return dispatch(logout());
    }
  };
};

var sidebar_component = connect(mapStateToProps, mapDispatchToProps)(dgWithReducer(Sidebar, "loggedInUser", loginReducer));

export { sidebar_component as default };
